import { AlertTriangle, Eye, Hand, MapPin, BookOpen } from "lucide-react";

const RULES = [
  { icon: Eye, title: "Identify with two sources, not one.", body: "Cross-check every plant against at least two reputable field guides or a knowledgeable forager before consuming. A photograph alone is not enough." },
  { icon: Hand, title: "Test one plant at a time.", body: "Eat a single bite of a new wild food and wait 24 hours before increasing the dose. Allergic and idiosyncratic reactions can be severe even with safe plants." },
  { icon: MapPin, title: "Don't harvest near contamination.", body: "Skip roadsides (lead, exhaust), commercial agriculture (pesticides, glyphosate drift), railway lines, and old industrial sites. Plantain and dandelion accumulate heavy metals from soil." },
  { icon: BookOpen, title: "Respect doses & cycles.", body: "Many wild plants are powerful — bitters, mobilizers and adaptogens are taken in courses, not daily forever. Each profile in the library spells out a cycle." },
  { icon: AlertTriangle, title: "Know the deadly lookalikes.", body: "Cilantro vs. poison hemlock. Wild carrot vs. hemlock. Chickweed vs. scarlet pimpernel. We list lookalikes in every profile — read them before you forage." },
];

export default function Foraging() {
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <p className="label-eyebrow">Foraging safety</p>
      <h1 className="font-serif text-5xl md:text-6xl mt-2 leading-[1.05]">Read this <span className="italic text-[var(--forest)]">before</span> anything else.</h1>
      <hr className="divider-rule" />
      <p className="text-lg text-[var(--ink-soft)] leading-relaxed">
        Wild plants are medicine. Some are also dangerous in the wrong dose,
        the wrong species, or the wrong soil. These five rules are
        non-negotiable.
      </p>

      <div className="mt-12 space-y-12">
        {RULES.map((r, i) => (
          <article key={r.title} className="grid grid-cols-[auto_1fr] gap-6 items-start" data-testid={`foraging-rule-${i}`}>
            <div className="w-12 h-12 border border-[var(--border-line)] flex items-center justify-center mt-1">
              <r.icon className="w-5 h-5 text-[var(--forest)]" strokeWidth={1.5} />
            </div>
            <div>
              <p className="label-eyebrow">Rule {i + 1}</p>
              <h2 className="font-serif text-2xl md:text-3xl mt-2">{r.title}</h2>
              <p className="text-[var(--ink-soft)] mt-2 leading-relaxed">{r.body}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
